import type { MouseEventHandler, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import s from './Button.module.scss';

type Props = {
  children: ReactNode;
  variant?: 'primary' | 'ghost';
  size?: 'md' | 'lg';
  to?: string;
  href?: string;
  type?: 'button' | 'submit';
  onClick?: MouseEventHandler;
  className?: string;
};

export default function Button({ children, variant = 'primary', size = 'md', to, href, type = 'button', onClick, className = '' }: Props) {
  const cls = `${s.btn} ${s[variant]} ${s[size]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={cls} onClick={onClick}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} onClick={onClick} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  }
  return (
    <button type={type} className={cls} onClick={onClick}>
      {children}
    </button>
  );
}
